// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CoverLetterEmptyState_wrapper__7z64O","create-cover-letter":"CoverLetterEmptyState_create-cover-letter__q85xK","line":"CoverLetterEmptyState_line__CDd94"};